export default {
    data() {
        return {
            //发票详情弹框
            dialogTableVisible: false,
            //人名搜索发票
            nameSearch: "",
            //订单号搜索发票
            orderNumSearch: "",
            //发票的数据
            invoices: [],
            //发票的偏移量
            invoiceOffset: 0,
            //每页请求的数目
            invoiceLength: 15,
            //发票的总数量
            invoiceTotal: 0,
            //搜索的支付类型选择
            orderSearchType: [{
                value: '1',
                label: "支付宝"
            }, {
                value: "2",
                label: "微信"
            }, {
                value: "3",
                label: "线下付款"
            }],
            //搜索时候的类型
            typeSearch: '',
            //搜索的发票状态类型
            invoicesStatusType: [{
                value: "0",
                label: "未开票"
            }, {
                value: "1",
                label: "开票中"
            }, {
                value: "2",
                label: "已开票"
            }],
			// 发票类型
			allInvoiceType:[{
                value: "0",
                label: "电子版"
            }, {
                value: "1",
                label: "纸质版"
            }],
            //搜索时的发票状态
            statusType: "",
			//搜索时的发票类型状态
			invoiceType: "",
            //点击某个订单时候的订单项
            order: {},
            //已经被选中的发票
            selectedInvoices: [],
        }
    },
    methods: {
        //计算一下状态
        countInvoiceStatus(state) {
            if (state == "0") {
                return "未开票"
            } else if (state == "1") {
                return "开票中"
            } else if (state == "2") {
                return "已开票"
            }
        },
        //搜索发票
        confirmSearch() {
            //判断支付类型和发票状态有没有选择，没有选择则为null则要进行置空
            String(this.typeSearch) == "null" ? this.typeSearch = "" : this.typeSearch;
            String(this.statusType) == "null" ? this.statusType = "" : this.statusType;
			String(this.invoiceType) == "null" ? this.invoiceType = "" : this.invoiceType;

            //获取筛选的数据
            let data = {
                token: this.$store.state.authority_management,
                offset: 0,
                length: this.invoiceLength,
                user_name: this.nameSearch,
                code: this.orderNumSearch,
                invoice_title_not_in: JSON.stringify([""]),
                invoice_title_not_null: 1,
                state: "2",
                pay_type: this.typeSearch,
                invoice_state: this.statusType,
            	invoice_type:this.invoiceType
            }
            //发送请求获取数据
            this.$post('orders/shop_search', data).then(res => {
                this.invoices = res.data.result.data;
                this.invoiceTotal = res.data.result.total;
            	// // console.log('voices',this.invoices)
            })
        },
        //已经被选中的行
        selectRow(val) {
            this.selectedInvoices = val;

        },
        //获取发票数据
        getInvoice() {
            //发给后端的数据
            let data = {
                token: this.$store.state.authority_management,
                offset: this.invoiceOffset,
                length: this.invoiceLength,
                user_name: this.nameSearch,
                code: this.orderNumSearch,
                invoice_title_not_in: JSON.stringify([""]),
                invoice_title_not_null: 1,
                state: "2",
                pay_type: this.typeSearch,
                invoice_state: this.statusType,
				invoice_type:this.invoiceType
            }
            //发送请求获取数据
            this.$post('orders/shop_search', data).then(res => {
                this.invoices = res.data.result.data;
                this.invoiceTotal = res.data.result.total;
				// // console.log('voices',this.invoices)
            })
        },
        //请求页面的数目发生变化
        handleSizeChange(val) {
            //根据val即页面数目值赋值
            this.invoiceLength = val;
            //再重新获取页面数据
            this.getInvoice();
        },
        //请求的页面发生变化
        handleCurrentChange(val) {
            //根据val获取页数
            this.invoiceOffset = (val - 1) * this.invoiceLength;
            //重新获取数据
            this.getInvoice();
        },
        //导出发票excel
        exportExcel() {
            //先判断是否有勾选发票
            if (this.selectedInvoices.length == 0) {
                this.$message({
                    message: "请至少选择一张发票导出",
                    type: "error"
                });
                return false;
            }
            //勾选订单筛选的东西
            let ids = [];
            //把勾选到的对象去除其他属性，留下id放入已选中发票的id数组
            this.selectedInvoices.map(item => {
                ids.push(item.id);
            })
            //随机数
            let randomNum = new Date().getTime();
            //发给后台的数据
            let data = {
                state: "2",
                ids: JSON.stringify(ids),
                token: this.$store.state.authority_management,
                offset: "0",
                length: "999999999999",
                file_name: String(randomNum)
            };
            //发送导出excel请求
            this.$post("orders/export_excel", data).then(res => {
                //接受到返回的信息后就拼接刚刚发送随机数下载即可
                window.open(this.exportUrl + String(randomNum) + ".csv")
                return true;
            }).then(res => {
                //发送后台的数据：token，选中的发票id数组
                let data = {
                    token: this.$store.state.authority_management,
                    ids: JSON.stringify(ids),
                    invoice_state: '1'
                }
                if (res) {
                    //发送修改发票状态为开票中的请求
                    this.$post("orders/edit", data).then(res => {
                        // // console.log(res.data);
                            if(res.data.status == "success"){
                                return true;
                            }
                    }).then(res => {
                        if(res){
                            //重新获取数据
                            this.getInvoice();
                        }
                    })
                }
            })
        },
        //查看详情
        handleDetail(obj) {
            // // console.log(obj)
            this.dialogTableVisible = true;
            this.order = obj;
        },
        //设置为已经开票状态
        alreadyOpenInvoice() {
            //循环已经选择的数组看看是否都是开票中状态的发票
            for (let val of this.selectedInvoices) {
                //如果有一个不是，则终止方法并提示
                if (val.invoice_state != "1") {
                    this.$message({
                        message: "设置为已开票状态的所选发票必须都是开票中状态的发票",
                        type: "error"
                    });
                    return false;
                }
				
            }
			
			if (this.selectedInvoices.length == 0) {
				    this.$message({
				        message: "请至少选择一张发票",
				        type: "error"
				    });
				    return false;
				}
			
            //已经选择的发票过滤出只有id属性
            let ids = [];
            this.selectedInvoices.map(item => {
                ids.push(item.id);
            })
            //修改发票状态发给后台的的数据
            let data = {
                token: this.$store.state.authority_management,
                ids: JSON.stringify(ids),
                invoice_state: '2'
            }
            //发送请求修改发票状态
            this.$post("orders/edit", data).then(res => {
                if (res.data.status == "success") {
                    this.$message({
                        message: "已经成功设置为已开票状态",
                        type: "success"
                    })
                    //刷新数据
                    this.getInvoice();
                } else {
                    this.$message({
                        message: "设置失败",
                        type: "error"
                    })
                }
            })
        }
    },
    created() {
        //获取订单数据
        this.getInvoice();
    }
}